// libs
import React, { useCallback } from 'react';

import { Close } from '@lyearn/icons';
// components
import { Chip, Typography } from '@lyearn/ui';

// styles
import { getClasses } from './styles';
// types
import { TagProps } from './types';

const Tag = (props: TagProps) => {
  const { option, onDelete } = props;

  const _onDelete = useCallback(() => {
    onDelete?.(option.optionId);
  }, [onDelete, option.optionId]);

  return (
    <Chip
      classes={getClasses(option.color)}
      deleteIcon={<Close className="h-16 w-16 flex-shrink-0 fill-current text-icon-placeholder" />}
      label={
        <Typography className="truncate me-4" color="text-text-paragraph" variant="body-short-02">
          {option.value}
        </Typography>
      }
      onDelete={onDelete ? _onDelete : undefined}
    />
  );
};

export default Tag;
